import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import portService from "../../services/portService";

export const fetchPorts=createAsyncThunk(
    "ports/fetch",
    async()=>{

        return await portService.getPorts();

    }
);

export const removePort=createAsyncThunk(
    "ports/delete",
    async(id)=>{

        await portService.deletePort(id);

        return id;

    }
);

export const addPort = createAsyncThunk(
    "ports/add",
    async (formData, thunkAPI) => {
        try {
            return await portService.addPort(formData);
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message
            );
        }
    }
);

const portSlice=createSlice({

    name:"ports",

    initialState:{
        ports:[],
        loading:false
    },

    reducers:{},

    extraReducers:(builder)=>{

        builder

.addCase(fetchPorts.pending,(state)=>{
    state.loading=true;
})

.addCase(fetchPorts.fulfilled,(state,action)=>{
    state.loading=false;
    state.ports=action.payload;
})

.addCase(fetchPorts.rejected,(state)=>{
    state.loading=false;
})

.addCase(addPort.fulfilled,(state,action)=>{

    state.ports.unshift(action.payload);

})

.addCase(removePort.fulfilled,(state,action)=>{

    state.ports=
    state.ports.filter(
        x=>x._id!==action.payload
    );

});

    }

});

export default portSlice.reducer;